<template>
  <ion-page>
    <PageHeaderWithMenu title="Миксы" :scrolled="headerScrolled" />
    <ion-content class="main-background playlist-list-content" :fullscreen="true" slot="fixed" @ionScroll="onContentScroll">
      <ion-segment :value="selectedListSegment" @ionChange="listSegmentChange($event)" mode="md" class="custom-segment">
        <ion-segment-button value="all">
          <ion-label>Все</ion-label>
        </ion-segment-button>
        <ion-segment-button value="favourites">
          <ion-label>Избранное</ion-label>
        </ion-segment-button>
      </ion-segment>

      <ion-content class="bg-transparent" v-show="selectedListSegment == 'all'">
        <ion-accordion-group>
          <div v-for="(program, programIdx) in programs" :key="programIdx">
            <ion-accordion class="bg-transparent" :value="program.programName">
              <ion-item slot="header" class="program-item" lines="none" color="violet">
                <div class="program-img-wrapper">
                  <img
                    :src="programLogos[program.shortName || ''] || getProgramImage(program.shortName || '')"
                    alt="program logo"
                    @error="onProgramLogoError(program.shortName)"
                  />
                </div>
              </ion-item>

              <ion-list slot="content" class="bg-transparent" lines="none">
                <ion-item class="release-item add-playlist-button" @click="addPlayList(program.programName)"
                  v-show="!globalContext.offlineMode" color="violet">
                  <ion-label class="ion-text-center">+</ion-label>
                </ion-item>

                <ion-item-sliding name="itemSliding-all" v-for="(playlist, playlistIdx) in playlistsByPrograms[
                  program.shortName || ''
                ]" :key="playlistIdx">
                  <ion-item class="release-item" :detail="true" color="violet">
                    <ion-icon v-if="playlist.offline" slot="start" :icon="checkmarkCircle" color="success" class="offline-indicator"></ion-icon>
                    <ion-label class="ion-text-center" @click="openPlaylist(playlist.id)">{{ playlist.name }}</ion-label>
                  </ion-item>
                  <ion-item-options side="start">
                    <ion-item-option color="success" @click="copyPlaylist(playlist)">
                      <ion-icon slot="icon-only" :icon="copy"></ion-icon>
                    </ion-item-option>
                  </ion-item-options>
                  <ion-item-options side="end"
                    @ionSwipe="addToFavourites(playlist.id, playlist.favourite ? false : true)">
                    <ion-item-option @click="changePlaylist(playlist.id)" color="warning" v-show="!playlist.isRelease">
                      <ion-icon :icon="createOutline"></ion-icon>
                    </ion-item-option>
                    <ion-item-option color="danger" @click="confirmRemovement(playlist.id)"><ion-icon
                        :icon="trashOutline"></ion-icon></ion-item-option>
                    <ion-item-option @click="addToFavourites(playlist.id, true)" color="success"
                      v-show="!playlist.favourite" expandable>
                      <ion-icon :icon="starOutline"></ion-icon>
                    </ion-item-option>
                    <ion-item-option @click="addToFavourites(playlist.id, false)" color="success"
                      v-show="playlist.favourite" class="white-icon" expandable>
                      <ion-icon :icon="star"></ion-icon>
                    </ion-item-option>
                  </ion-item-options>
                </ion-item-sliding>
              </ion-list>
            </ion-accordion>
          </div>
        </ion-accordion-group>
        <div v-if="playlistsNotInAnyAccordion.length" class="orphan-playlists-wrap">
          <ion-list class="bg-transparent" lines="none">
            <ion-item class="program-item orphan-program-header" lines="none" color="medium">
              <ion-label class="ion-text-wrap ion-padding-vertical">
                Миксы вне списка программ (исправится после выбора программы при редактировании)
              </ion-label>
            </ion-item>
            <ion-item-sliding
              v-for="playlist in playlistsNotInAnyAccordion"
              :key="'orphan-' + playlist.id"
              name="itemSliding-all"
            >
              <ion-item class="release-item" :detail="true" color="medium">
                <ion-icon
                  v-if="playlist.offline"
                  slot="start"
                  :icon="checkmarkCircle"
                  color="success"
                  class="offline-indicator"
                ></ion-icon>
                <ion-label class="ion-text-center" @click="openPlaylist(playlist.id)">{{ playlist.name }}</ion-label>
              </ion-item>
              <ion-item-options side="start">
                <ion-item-option color="success" @click="copyPlaylist(playlist)">
                  <ion-icon slot="icon-only" :icon="copy"></ion-icon>
                </ion-item-option>
              </ion-item-options>
              <ion-item-options side="end" @ionSwipe="addToFavourites(playlist.id, playlist.favourite ? false : true)">
                <ion-item-option @click="changePlaylist(playlist.id)" color="warning" v-show="!playlist.isRelease">
                  <ion-icon :icon="createOutline"></ion-icon>
                </ion-item-option>
                <ion-item-option color="danger" @click="confirmRemovement(playlist.id)">
                  <ion-icon :icon="trashOutline"></ion-icon>
                </ion-item-option>
                <ion-item-option @click="addToFavourites(playlist.id, true)" color="success" v-show="!playlist.favourite" expandable>
                  <ion-icon :icon="starOutline"></ion-icon>
                </ion-item-option>
                <ion-item-option @click="addToFavourites(playlist.id, false)" color="success" v-show="playlist.favourite" class="white-icon" expandable>
                  <ion-icon :icon="star"></ion-icon>
                </ion-item-option>
              </ion-item-options>
            </ion-item-sliding>
          </ion-list>
        </div>
        <ion-item class="bg-transparent fake-item" lines="none"></ion-item>

        <ion-modal
          :is-open="showEditPlaylist"
          class="playlist-edit-modal"
          @willPresent="willPresentEditPlaylist()"
          @willDismiss="closeTrackPreview()"
        >
          <ion-content class="playlist-container playlist-edit-body" :scroll-y="true">
            <ion-header mode="md" class="playlist-edit-header">
              <ion-toolbar class="playlist-edit-toolbar">
                <ion-title class="playlist-edit-toolbar-title">Редактор микса</ion-title>
                <ion-buttons slot="end">
                  <ion-button class="playlist-edit-save-btn" @click="savePlaylist()">Сохранить</ion-button>
                  <ion-button class="playlist-header-button playlist-edit-close-btn" fill="clear" @click="closeEditPlaylist()">
                    Закрыть
                  </ion-button>
                </ion-buttons>
              </ion-toolbar>
            </ion-header>

            <div class="playlist-edit-scroll-inner">
              <div class="playlist-edit-subbar">
                <span class="playlist-edit-subbar__title">{{ editModalDisplayTitle }}</span>
                <span class="playlist-edit-subbar__chips">
                  <span class="playlist-edit-chip playlist-edit-chip--tiny">
                    <ion-icon :icon="musicalNotesOutline"></ion-icon>
                    {{ editSelectedTrackCount }} {{ editTrackCountLabel }}
                  </span>
                  <span class="playlist-edit-chip playlist-edit-chip--tiny">
                    <ion-icon :icon="timeOutline"></ion-icon>
                    {{ editTracksDurationFormatted }}
                  </span>
                </span>
              </div>

              <div class="playlist-edit-form-grid">
                <ion-item lines="none" class="playlist-edit-field playlist-edit-field--compact">
                  <ion-label position="floating" class="playlist-edit-label">Название</ion-label>
                  <ion-input
                    type="text"
                    v-model="editPlaylist.name"
                    class="playlist-name-input playlist-edit-input"
                  ></ion-input>
                </ion-item>

                <ion-item lines="none" class="playlist-edit-field playlist-edit-field--compact">
                  <ion-label position="floating" class="playlist-edit-label">Программа</ion-label>
                  <ion-select
                    :value="selectedProgram.programName"
                    v-model="selectedProgram"
                    interface="popover"
                    mode="ios"
                    :interface-options="customPopoverOptions"
                    class="playlist-edit-select"
                    placeholder="Программа"
                    @ionChange="programChanged()"
                  >
                    <ion-select-option v-for="program in programs" :key="program.shortName" :value="program">{{
                      program.programName }}</ion-select-option>
                  </ion-select>
                </ion-item>

                <ion-item
                  v-show="selectedProgram.programName !== ''"
                  lines="none"
                  class="playlist-edit-field playlist-edit-field--compact"
                >
                  <ion-label position="floating" class="playlist-edit-label">Релиз</ion-label>
                  <ion-select
                    :value="selectedRelease"
                    v-model="selectedRelease"
                    interface="popover"
                    mode="ios"
                    :interface-options="customPopoverOptions"
                    class="playlist-edit-select"
                    placeholder="Релиз"
                    @ionChange="releaseChanged()"
                  >
                    <ion-select-option
                      v-for="(release, idx) in getProgramReleases(selectedProgram.programName)"
                      :key="idx"
                      :value="release"
                    >{{ release }}</ion-select-option>
                  </ion-select>
                </ion-item>
              </div>

              <ion-list lines="none" class="playlist-content playlist-edit-track-block">
                <ion-list-header class="playlist-edit-section-head">
                  <ion-label class="playlist-header-label playlist-edit-section-title">Треки микса</ion-label>
                  <ion-label class="playlist-edit-section-meta">{{
                    mediaUtils.formatTime(mediaUtils.getTotalPlaylistDuration(selectedTracks))
                  }}</ion-label>
                </ion-list-header>
                <ion-text v-show="selectedRelease === '' && selectedLibraryFolderId <= 0" class="playlist-edit-hint">
                  Ниже откройте «Добавить из релиза» или выберите папку каталога и «Добавить из каталога».
                </ion-text>
                <div class="playlist-content playlist-edit-track-list">
                  <ion-reorder-group @ionItemReorder="reorderPlaylist($event)" :disabled="false">
                    <ion-item-sliding v-for="track in selectedTracks" :key="track.id">
                      <ion-item>
                        <ion-reorder slot="start"></ion-reorder>
                        <ion-label>{{ mediaUtils.getTrackName(track) }}</ion-label>
                        <ion-label slot="end">{{ mediaUtils.formatTime(track.duration) }}</ion-label>
                      </ion-item>
                      <ion-item-options side="end">
                        <ion-item-option @click="removeTrack(track)" color="danger">
                          <ion-icon :icon="trashOutline"></ion-icon>
                        </ion-item-option>
                      </ion-item-options>
                    </ion-item-sliding>
                  </ion-reorder-group>
                </div>
              </ion-list>

              <div
                :class="['playlist-edit-expand-wrap', releaseTracksVisible ? 'playlist-edit-expand-wrap--open' : '']"
                v-show="selectedRelease !== ''"
              >
                <ion-button class="playlist-edit-expand-btn" fill="outline" size="small" @click="showReleaseTracks()">
                  <ion-icon slot="start" :icon="add" :class="[releaseTracksVisible ? 'close-button' : '']"></ion-icon>
                  {{ releaseTracksVisible ? "Скрыть треки релиза" : "Добавить из релиза" }}
                </ion-button>
              </div>

              <ion-list lines="none" class="playlist-content playlist-edit-track-block ion-margin-bottom" v-show="releaseTracksVisible">
                <ion-list-header class="playlist-edit-section-head">
                  <ion-label class="playlist-header-label playlist-edit-section-title">{{
                    `${selectedProgram.programName} · ${selectedRelease}`
                  }}</ion-label>
                  <ion-label class="playlist-edit-section-meta">{{
                    mediaUtils.formatTime(mediaUtils.getTotalPlaylistDuration(musicList))
                  }}</ion-label>
                </ion-list-header>
                <div class="playlist-content playlist-edit-track-list">
                  <ion-item v-for="(track, idx) in musicList" :key="idx" class="preview-item">
                    <div
                      v-show="track.id == previewTrackId"
                      class="preview-progress"
                      :style="{ width: `${(previewCurrentPosition / previewDuration) * 100}%` }"
                    ></div>
                    <ion-icon
                      @click="previewTrack(track)"
                      slot="start"
                      :icon="previewPlaying && track.id == previewTrackId ? pause : play"
                      class="play-button"
                      v-show="!previewLoading || track.id !== previewTrackId"
                    ></ion-icon>
                    <ion-spinner slot="start" name="bubbles" v-show="track.id == previewTrackId && previewLoading"></ion-spinner>
                    <ion-label>{{ mediaUtils.getTrackName(track) }}</ion-label>
                    <ion-label slot="end">{{ mediaUtils.formatTime(track.duration) }}</ion-label>
                    <ion-icon
                      slot="end"
                      :icon="add"
                      @click="addTrack(track)"
                      :class="[isAdded(track) ? 'close-button danger-button' : 'add-button']"
                    ></ion-icon>
                  </ion-item>
                </div>
              </ion-list>

              <ion-item lines="none" class="playlist-edit-field playlist-edit-field--compact">
                <ion-label position="floating" class="playlist-edit-label">Каталог музыки</ion-label>
                <ion-select
                  v-model="selectedLibraryFolderId"
                  interface="popover"
                  mode="ios"
                  class="playlist-edit-select"
                  placeholder="Папка"
                  @ionChange="onLibraryFolderChange()"
                >
                  <ion-select-option :value="0">Не выбрано</ion-select-option>
                  <ion-select-option v-for="lf in libraryFolders" :key="lf.id" :value="lf.id">{{ lf.title }}</ion-select-option>
                </ion-select>
              </ion-item>

              <div
                :class="['playlist-edit-expand-wrap', libraryTracksVisible ? 'playlist-edit-expand-wrap--open' : '']"
                v-show="selectedLibraryFolderId > 0"
              >
                <ion-button class="playlist-edit-expand-btn" fill="outline" size="small" @click="toggleLibraryTracks()">
                  <ion-icon slot="start" :icon="add" :class="[libraryTracksVisible ? 'close-button' : '']"></ion-icon>
                  {{ libraryTracksVisible ? "Скрыть каталог" : "Добавить из каталога" }}
                </ion-button>
              </div>

              <ion-list
                lines="none"
                class="playlist-content playlist-edit-track-block ion-margin-bottom"
                v-show="libraryTracksVisible && selectedLibraryFolderId > 0"
              >
                <ion-list-header class="playlist-edit-section-head">
                  <ion-label class="playlist-header-label playlist-edit-section-title">Треки каталога</ion-label>
                  <ion-label class="playlist-edit-section-meta">{{
                    mediaUtils.formatTime(mediaUtils.getTotalPlaylistDuration(libraryMusicList))
                  }}</ion-label>
                </ion-list-header>
                <div class="playlist-content playlist-edit-track-list">
                  <ion-item v-for="(track, lidx) in libraryMusicList" :key="'lib-' + track.id + lidx" class="preview-item">
                    <ion-icon
                      @click="previewTrack(track)"
                      slot="start"
                      :icon="previewPlaying && track.id == previewTrackId ? pause : play"
                      class="play-button"
                      v-show="!previewLoading || track.id !== previewTrackId"
                    ></ion-icon>
                    <ion-spinner slot="start" name="bubbles" v-show="track.id == previewTrackId && previewLoading"></ion-spinner>
                    <ion-label>{{ mediaUtils.getTrackName(track) }}</ion-label>
                    <ion-label slot="end">{{ mediaUtils.formatTime(track.duration) }}</ion-label>
                    <ion-icon
                      slot="end"
                      :icon="add"
                      @click="addTrack(track)"
                      :class="[isAdded(track) ? 'close-button danger-button' : 'add-button']"
                    ></ion-icon>
                  </ion-item>
                </div>
              </ion-list>

              <div class="playlist-edit-scroll-pad" aria-hidden="true"></div>
            </div>
          </ion-content>
        </ion-modal>
      </ion-content>

      <ion-content class="bg-transparent favourites-content" v-show="selectedListSegment == 'favourites'">
        <div v-for="(program, programIdx) in programs" :key="programIdx">
          <ion-list slot="content" class="bg-transparent" lines="none">
            <div v-for="(playlist, playlistIdx) in playlistsByPrograms[
              program.shortName || ''
            ]" :key="playlistIdx">
              <ion-item-sliding v-if="playlist.favourite" name="itemSliding-favourites">
                <ion-item class="release-item release-favourite-item" :detail="true" color="violet">
                  <ion-label class="ion-text-center" @click="openPlaylist(playlist.id)">{{ `${playlist.programName} -
                                      ${playlist.name}` }}</ion-label>
                </ion-item>
                <ion-item-options side="start">
                  <ion-item-option color="success" @click="copyPlaylist(playlist)">
                    <ion-icon slot="icon-only" :icon="copy"></ion-icon>
                  </ion-item-option>
                </ion-item-options>
                <ion-item-options side="end" @ionSwipe="addToFavourites(playlist.id, playlist.favourite ? false : true)">
                  <ion-item-option @click="changePlaylist(playlist.id)" color="warning" v-show="!playlist.isRelease">
                    <ion-icon :icon="createOutline"></ion-icon>
                  </ion-item-option>
                  <ion-item-option color="danger" @click="confirmRemovement(playlist.id)"><ion-icon
                      :icon="trashOutline"></ion-icon></ion-item-option>
                  <ion-item-option @click="addToFavourites(playlist.id, true)" color="success"
                    v-show="!playlist.favourite" expandable>
                    <ion-icon :icon="starOutline"></ion-icon>
                  </ion-item-option>
                  <ion-item-option @click="addToFavourites(playlist.id, false)" color="success"
                    v-show="playlist.favourite" expandable>
                    <ion-icon :icon="star"></ion-icon>
                  </ion-item-option>
                </ion-item-options>
              </ion-item-sliding>
            </div>
          </ion-list>
        </div>
        <ion-item class="bg-transparent fake-item" lines="none"></ion-item>
      </ion-content>

      <ion-loading cssClass="liga-loading" spinner="lines" :is-open="isSavingRef" message="Сохранение...">
      </ion-loading>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import { GlobalContext } from "@/model/globalcontext.model";
import { GoogleMedia } from "@/model/googlemedia.model";
import { MediaProgressBar } from "@/model/mediaprogressbar.model";
import { PlayerBar } from "@/model/playerbar.model";
import { Playlist } from "@/model/playlist.model";
import { Program } from "@/model/program.model";
import FilesystemCustomUtils from "@/services/filesystem.custom.utils";
import LogoService, { bundledProgramImageUrl } from "@/services/logo.service";
import MediaUtils from "@/services/media.utils";
import UnicodeUtils from "@/services/unicode.utils";
import { CapacitorHttp } from "@capacitor/core";
import { Directory, Encoding, Filesystem } from "@capacitor/filesystem";
import { Preferences } from "@capacitor/preferences";
import {
    IonAccordion,
    IonAccordionGroup,
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonInput,
    IonItem,
    IonItemOption,
    IonItemOptions,
    IonItemSliding,
    IonLabel,
    IonList,
    IonListHeader,
    IonLoading,
    IonModal,
    IonPage,
    IonReorder,
    IonReorderGroup,
    IonSegment,
    IonSegmentButton,
    IonSelect,
    IonSelectOption,
    IonSpinner,
    IonText,
    IonTitle,
    IonToolbar,
    alertController,
    isPlatform,
} from "@ionic/vue";
import axios from "axios";
import { RmxAudioPlayer } from "capacitor-plugin-playlist";
import dayjs from "dayjs";
import {
    add,
    checkmarkCircle,
    close,
    copy,
    createOutline,
    musicalNotesOutline,
    pause,
    play,
    star,
    starOutline,
    timeOutline,
    trashOutline,
} from "ionicons/icons";
import { defineComponent, inject, ref } from "vue";
// @ts-ignore
import { MittEmitter } from "mitt-emitter";
import PageHeaderWithMenu from "@/components/PageHeaderWithMenu.vue";
import store from "@/store";
import { ILibraryMusicFolder, libraryMusicService } from "@/services/library-music.service";

export default defineComponent({
  name: "PlaylistList",
  components: {
    PageHeaderWithMenu,
    IonContent,
    IonPage,
    IonAccordionGroup,
    IonAccordion,
    IonList,
    IonListHeader,
    IonLabel,
    IonItem,
    IonItemSliding,
    IonItemOptions,
    IonItemOption,
    IonModal,
    IonSelect,
    IonSelectOption,
    IonInput,
    IonButton,
    IonIcon,
    IonText,
    IonReorderGroup,
    IonReorder,
    IonHeader,
    IonTitle,
    IonButtons,
    IonToolbar,
    IonLoading,
    IonSpinner,
    IonSegment,
    IonSegmentButton,
  },
  setup() {
    const globalContext = inject("globalContext") as GlobalContext;
    const PLAYLISTS_DIRECTORY = "playlists";
    const PROGRAMS_PATH = "programs.json";
    const PLAYLIST_PATH = "playlist.json";

    const playerBar = inject("playerBar") as PlayerBar;
    const audioPlayer = inject("audioPlayer") as RmxAudioPlayer;
    const emitter = inject("emitter") as MittEmitter;
    const unicodeUtils = new UnicodeUtils();
    const mediaUtils = new MediaUtils();
    const filesystemCustomUtils = new FilesystemCustomUtils();

    const customPopoverOptions: any = {
      cssClass: "month-selector",
    };

    const isSavingRef = ref(false);
    const setSaving = (state: boolean) => {
      isSavingRef.value = state;
    };

    return {
      globalContext,
      PLAYLISTS_DIRECTORY,
      PROGRAMS_PATH,
      PLAYLIST_PATH,
      audioPlayer,
      add,
      checkmarkCircle,
      close,
      trashOutline,
      createOutline,
      play,
      pause,
      copy,
      playerBar,
      emitter,
      customPopoverOptions,
      unicodeUtils,
      mediaUtils,
      setSaving,
      isSavingRef,
      filesystemCustomUtils,
      starOutline,
      star,
      musicalNotesOutline,
      timeOutline,
    };
  },
  data() {
    return {
      playlists: Array<Playlist>(),
      musicList: Array<GoogleMedia>(),
      programs: Array<Program>(),
      showEditPlaylist: false,
      releaseTracksVisible: false,
      editPlaylist: new Playlist("", "", ""),
      selectedProgram: new Program(0, "", "", "", false, [], []),
      selectedRelease: "",
      selectedTracks: Array<GoogleMedia>(),
      selectedPlaylist: new Playlist("", "", ""),
      downloaded: 0,
      downloading: false,
      downloadProgressBar: new MediaProgressBar(),
      previewTrackId: "",
      previewTrackPath: "",
      selectedListSegment: "all",
      programLogos: {} as Record<string, string>,
      logoService: new LogoService(),
      headerScrolled: false,
      libraryFolders: [] as ILibraryMusicFolder[],
      selectedLibraryFolderId: 0,
      libraryMusicList: [] as GoogleMedia[],
      libraryTracksVisible: false,
      /** Сбрасывается в ionViewWillEnter; после открытия редактора по ?edit= не повторять */
      pendingEditFromRouteHandled: false,
    };
  },

  watch: {
    playlists: {
      handler() {
        this.maybeOpenEditFromRoute();
      },
      deep: true,
    },
    programs: {
      handler() {
        this.maybeOpenEditFromRoute();
      },
      deep: true,
    },
  },

  computed: {
    playlistsByPrograms(): any {
      return this.groupBy(this.playlists, "programShortName");
    },

    musicDirectory(): string {
      return `${this.selectedProgram.shortName +
        "_" +
        (this.selectedRelease.length === 1
          ? "0" + this.selectedRelease
          : this.selectedRelease) +
        "_Music"
        }`;
    },

    previewLoading(): boolean {
      return !this.playerBar.isReady;
    },
    previewPlaying(): boolean {
      return this.playerBar.playing || false;
    },
    previewDuration(): number {
      return this.playerBar.currentDuration;
    },
    previewCurrentPosition(): number {
      return this.playerBar.currentPosition;
    },

    editModalDisplayTitle(): string {
      const n = this.editPlaylist.name?.trim();
      return n ? n : "Новый микс";
    },

    editSelectedTrackCount(): number {
      return this.selectedTracks?.length ?? 0;
    },

    editTracksDurationFormatted(): string {
      return this.mediaUtils.formatTime(
        this.mediaUtils.getTotalPlaylistDuration(this.selectedTracks)
      );
    },

    editTrackCountLabel(): string {
      const n = this.editSelectedTrackCount;
      const mod10 = n % 10;
      const mod100 = n % 100;
      if (mod100 >= 11 && mod100 <= 14) return "треков";
      if (mod10 === 1) return "трек";
      if (mod10 >= 2 && mod10 <= 4) return "трека";
      return "треков";
    },

    /** Плейлисты, которые не попали ни под один аккордеон (ключ — program.shortName || '') */
    playlistsNotInAnyAccordion(): Playlist[] {
      return this.playlists.filter(
        (pl) => !this.programs.some((p) => (p.shortName || "") === (pl.programShortName || ""))
      );
    },
  },

  ionViewWillEnter() {
    this.pendingEditFromRouteHandled = false;
    this.getAllPlaylists();
    this.getPrograms();
  },

  methods: {
    maybeOpenEditFromRoute() {
      if (this.pendingEditFromRouteHandled || this.showEditPlaylist) return;
      const raw = this.$route.query.edit;
      const id = typeof raw === "string" ? raw : Array.isArray(raw) ? raw[0] : "";
      if (!id) return;
      const found = this.playlists.find((p) => p.id === id);
      if (!found) {
        if (this.playlists.length > 0) {
          this.pendingEditFromRouteHandled = true;
          this.$router.replace({ path: "/playlist-list", query: {} });
        }
        return;
      }
      this.pendingEditFromRouteHandled = true;
      this.changePlaylist(id);
      this.$router.replace({ path: "/playlist-list", query: {} });
    },
    onContentScroll(e: CustomEvent) {
      const scrollTop = (e.target as HTMLElement)?.scrollTop ?? 0;
      (this as { headerScrolled: boolean }).headerScrolled = scrollTop > 16;
    },
    closeSliding() {
      const itemSliding = document.getElementsByName(`itemSliding-${this.selectedListSegment}`);
      for (let i = 0; i < itemSliding.length; i++) {
        (itemSliding[i] as any).closeOpened();
      }
    },

    listSegmentChange(event: CustomEvent): void {
      this.selectedListSegment = event.detail.value;
    },

    async loadLibraryFolders() {
      if (this.globalContext.offlineMode) {
        this.libraryFolders = [];
        return;
      }
      try {
        this.libraryFolders = await libraryMusicService.listUserFolders();
      } catch {
        this.libraryFolders = [];
      }
    },

    onLibraryFolderChange() {
      this.closeTrackPreview();
      this.libraryMusicList = [];
    },

    async toggleLibraryTracks() {
      this.libraryTracksVisible = !this.libraryTracksVisible;
      if (this.libraryTracksVisible && this.selectedLibraryFolderId > 0) {
        try {
          this.libraryMusicList = await libraryMusicService.listUserTracks(this.selectedLibraryFolderId);
        } catch {
          this.libraryMusicList = [];
        }
      }
      if (!this.libraryTracksVisible) {
        this.closeTrackPreview();
      }
    },

    /** Подставить shortName / programName из справочника программ, чтобы группировка в списке работала */
    normalizePlaylistProgramFields(playlist: Playlist) {
      if (!playlist || !this.programs.length) return;
      const name = playlist.programName?.trim();
      const short = playlist.programShortName?.trim();
      if (name && !short) {
        const m = this.programs.find((p) => p.programName === name);
        if (m?.shortName) {
          playlist.programShortName = m.shortName;
        }
      }
      if (short && !playlist.programName?.trim()) {
        const m = this.programs.find((p) => (p.shortName || "") === short);
        if (m?.programName) {
          playlist.programName = m.programName;
        }
      }
    },

    normalizeAllPlaylistProgramFields() {
      if (!this.playlists.length || !this.programs.length) return;
      this.playlists.forEach((p) => this.normalizePlaylistProgramFields(p));
    },

    sortPlaylistsAfterLoad() {
      this.normalizeAllPlaylistProgramFields();
      this.playlists.sort((a, b) => {
        let bySortIdx = 0;
        if (a.sortIdx > b.sortIdx) bySortIdx = -1;
        if (a.sortIdx > b.sortIdx) bySortIdx = 1;

        let byProgram = 0;
        if (a.programShortName > b.programShortName) byProgram = -1;
        if (a.programShortName > b.programShortName) byProgram = 1;

        let byName = 0;
        if (a.name > b.name) byName = -1;
        if (a.name > b.name) byName = 1;

        return byProgram || bySortIdx || byName;
      });

      this.playlists.forEach((playlistItem, index) => {
        playlistItem.sortIdx = index;
      });
    },

    async previewTrack(track: GoogleMedia): Promise<void> {
      const tokenQuery = await Preferences.get({ key: "jwt" });
      const token = tokenQuery.value;

      if (this.audioPlayer && this.audioPlayer.isPlaying) {
        this.audioPlayer.pause();
      } else if (this.previewTrackId == track.id && this.audioPlayer && this.audioPlayer.hasLoaded && this.audioPlayer.isPaused) {
        this.audioPlayer.play();
      }

      if (this.previewTrackId !== track.id) {
        this.previewTrackId = track.id;
        
        // Check if track is from server (path starts with "releases/" or library_music/)
        const isServerTrack = track.id.startsWith('releases/');
        const isLibraryTrack = track.id.startsWith('library_music/');

        if (isServerTrack || isLibraryTrack) {
          const streamBase = isLibraryTrack ? 'library-music' : 'releases';
          const options = {
            url: `${process.env.VUE_APP_API_URL}api/${streamBase}/stream-request?path=${encodeURIComponent(track.id)}`,
            headers: { Authorization: `Bearer ${token}` },
            readTimeout: 60000,
          };

          CapacitorHttp.get(options)
            .then((response) => {
              let data = response.data;
              if (typeof data === 'string') {
                try {
                  data = JSON.parse(data);
                } catch {
                  /* keep */
                }
              }
              if (data && data.streamUrl) {
                this.previewTrackPath = data.streamUrl;
              } else {
                this.previewTrackPath = `${process.env.VUE_APP_API_URL}api/${streamBase}/stream?path=${encodeURIComponent(track.id)}`;
              }
            })
            .catch(() => {
              this.previewTrackPath = `${process.env.VUE_APP_API_URL}api/${streamBase}/stream?path=${encodeURIComponent(track.id)}`;
            })
            .finally(() => {
              if (this.audioPlayer) {
                const albumLabel = isLibraryTrack
                  ? 'Каталог'
                  : `${this.selectedProgram.programName} - ${this.selectedRelease}`;
                this.audioPlayer.setPlaylistItems([
                  {
                    isStream: false,
                    trackId: this.previewTrackId,
                    assetUrl: this.previewTrackPath,
                    artist: "Liga.Team",
                    albumArt: '',
                    album: albumLabel,
                    title: this.mediaUtils.getTrackName(track),
                  }
                ],
                  {
                    playFromPosition: 0,
                    playFromId: this.previewTrackId,
                    startPaused: false
                  });
              }
            });
        } else {
          // Original Google Drive logic
          this.previewTrackPath = `${process.env.VUE_APP_API_URL}api/google/music/${track.id}`;

          const options = {
            url: `${process.env.VUE_APP_API_URL
              }api/google/media/storage/${this.previewTrackId}.${this.filesystemCustomUtils.mimeExtensions.get(
                track.mimeType
              )}`,
            headers: { Authorization: `Bearer ${token}` },
            readTimeout: 60000,
          };

          CapacitorHttp.get(options)
            .then((response) => {
              if (response.data) {
                this.previewTrackPath = `${process.env.VUE_APP_MEDIA_URL
                  }media/${this.previewTrackId}.${this.filesystemCustomUtils.mimeExtensions.get(
                    track.mimeType
                  )}`;
              } else {
                this.previewTrackPath = `${process.env.VUE_APP_API_URL}api/google/music/${this.previewTrackId}`;
              }
            })
            .catch(() => {
              this.previewTrackPath = `${process.env.VUE_APP_API_URL}api/google/music/${this.previewTrackId}`;
            }).finally(() => {
              if (this.audioPlayer) {
                this.audioPlayer.setPlaylistItems([
                  {
                    isStream: false,
                    trackId: this.previewTrackId,
                    assetUrl: this.previewTrackPath,
                    artist: "Liga.Team",
                    albumArt: '',
                    album: `${this.selectedProgram.programName} - ${this.selectedRelease}`,
                    title: this.mediaUtils.getTrackName(track),
                  }
                ],
                  {
                    playFromPosition: 0,
                    playFromId: this.previewTrackId,
                    startPaused: false
                  });
              }
            });
        }
      }
    },

    closeTrackPreview(): void {
      if (this.audioPlayer) {
        this.audioPlayer.pause();
      }
      this.previewTrackId = "";
    },

    async loadProgramLogos() {
      const loadPromises = this.programs.map(async (program: Program) => {
        if (program.shortName) {
          try {
            const logoUrl = await this.logoService.getProgramLogo(program.shortName);
            this.programLogos[program.shortName] = logoUrl;
          } catch (error) {
            console.error(`Failed to load logo for ${program.shortName}:`, error);
          }
        }
      });
      
      await Promise.allSettled(loadPromises);
    },

    getProgramImage(shortName: string): string {
      return bundledProgramImageUrl(shortName);
    },

    onProgramLogoError(shortName: string | undefined) {
      if (!shortName) return;
      this.logoService.forgetProgramLogo(shortName);
      this.programLogos[shortName] = bundledProgramImageUrl(shortName);
    },

    async getPrograms() {
      if (this.globalContext.offlineMode) {
        //try to load local programs
        Filesystem.readFile({
          path: `${this.PLAYLISTS_DIRECTORY}/${this.PROGRAMS_PATH}`,
          directory: Directory.Data,
          encoding: Encoding.UTF8,
        })
          .then((programsFile) => {
            this.programs = JSON.parse(typeof programsFile.data === 'string' ? programsFile.data : '');
            this.loadProgramLogos();
            this.normalizeAllPlaylistProgramFields();
            this.sortPlaylistsAfterLoad();
          })
          .catch((err) => {
            console.error("Failed to load local programs list", err);
          });
        return;
      }

      if (isPlatform("ios") || isPlatform("android")) {
        const tokenQuery = await Preferences.get({ key: "jwt" });
        const token = tokenQuery.value;

        const options = {
          url: `${process.env.VUE_APP_API_URL}api/programs-with-releases`,
          headers: { Authorization: `Bearer ${token}` },
          readTimeout: 60000,
        };

        await CapacitorHttp.get(options)
          .then((response) => {
            this.programs = response.data;
            this.filesystemCustomUtils.storeFile(
              (JSON.stringify(this.programs)),
              this.PROGRAMS_PATH,
              this.PLAYLISTS_DIRECTORY
            );
            this.loadProgramLogos();
            this.normalizeAllPlaylistProgramFields();
            this.sortPlaylistsAfterLoad();
          })
          .catch(() => {
            this.$router.replace("/badconnection");
          });
      } else {
        axios
          .get("/api/programs-with-releases")
          .then((response) => {
            this.programs = response.data;
            this.loadProgramLogos();
            this.normalizeAllPlaylistProgramFields();
            this.sortPlaylistsAfterLoad();
          })
          .catch(() => {
            this.$router.replace("/badconnection");
          });
      }
    },

    getProgramReleases(programName?: string): string[] {
      if (!programName) return [];

      const filteredProgram = this.programs.filter((program) => {
        return program.programName == programName;
      });

      if (
        null != filteredProgram &&
        filteredProgram.length > 0 &&
        filteredProgram[0].releases
      ) {
        return filteredProgram[0].releases
          .map((r) => {
            return r.length > 1 ? r : `0${r}`;
          })
          .sort();
      }

      return [];
    },

    getAllPlaylists() {
      if (isPlatform("ios") || isPlatform("android")) {
        this.playlists = new Array<Playlist>();
        Filesystem.readdir({
          path: this.PLAYLISTS_DIRECTORY,
          directory: Directory.Data,
        })
          .then((playlistDirs) => {
            for (let i = 0; i < playlistDirs.files.length; i++) {
              Filesystem.readdir({
                path: `${this.PLAYLISTS_DIRECTORY}/${playlistDirs.files[i].name}`,
                directory: Directory.Data,
              })
                .then((res) => {
                  const foundPlaylist = res.files.find((f) => {
                    return f.name == this.PLAYLIST_PATH;
                  });

                  if (
                    typeof foundPlaylist !== "undefined" &&
                    null != foundPlaylist
                  ) {
                    Filesystem.readFile({
                      path: `${this.PLAYLISTS_DIRECTORY}/${playlistDirs.files[i].name}/${this.PLAYLIST_PATH}`,
                      directory: Directory.Data,
                      encoding: Encoding.UTF8,
                    })
                      .then((res) => {
                        const localPlaylist: Playlist = typeof res.data === 'string' ? JSON.parse(res.data) : null;
                        if (!localPlaylist) throw new Error("Local playlist is null");

                        const filesystemCustomUtils =
                          new FilesystemCustomUtils();
                        filesystemCustomUtils
                          .isPlaylistOffline(
                            this.PLAYLISTS_DIRECTORY,
                            localPlaylist
                          )
                          .then((response) => {
                            localPlaylist.offline = response;
                            this.playlists.push(localPlaylist);
                          });
                      })
                      .catch((err) => {
                        console.error("Failed to load local playlist", err);
                      });
                  }
                })
                .catch(() => {
                  // not exists or not a dir
                });
            }
          })
          .catch(() => {
            // not exists
          });
      } else {
        this.playlists = new Array<Playlist>();
        const finishSort = () => this.sortPlaylistsAfterLoad();
        const parseRows = (rows: Array<{ content?: string }>) => {
          this.playlists = rows
            .map((row) => {
              if (!row.content) return null;
              try {
                return JSON.parse(row.content) as Playlist;
              } catch {
                return null;
              }
            })
            .filter((p): p is Playlist => p != null);
          finishSort();
        };
        const loadFromApi = (userId: number) => {
          axios
            .get<Array<{ content?: string }>>(`/api/playlist/${userId}`)
            .then(({ data }) => {
              parseRows(Array.isArray(data) ? data : []);
            })
            .catch(() => {
              this.playlists = [];
              finishSort();
            });
        };

        const acc = store.getters.account as { id?: number } | null | undefined;
        if (acc?.id) {
          loadFromApi(acc.id);
        } else {
          axios
            .get<{ id?: number } & Record<string, unknown>>("/api/account")
            .then(({ data }) => {
              if (data?.id) {
                if (!store.getters.account) {
                  store.commit("authenticated", data);
                }
                loadFromApi(data.id);
              } else {
                finishSort();
              }
            })
            .catch(() => {
              this.playlists = [];
              finishSort();
            });
        }
      }

      if (isPlatform("ios") || isPlatform("android")) {
        this.sortPlaylistsAfterLoad();
      }
    },

    addPlayList(programName?: string) {
      if (!programName) return;

      this.showEditPlaylist = true;
      const found = this.programs.find((p) => {
        return p.programName === programName;
      });
      if (typeof found !== "undefined" && found !== null) {
        this.selectedProgram = found;
      }
    },

    willPresentEditPlaylist() {
      //clear fields
      this.selectedRelease = "";
      this.releaseTracksVisible = false;
      this.loadLibraryFolders();
    },

    didDismissEditPlaylist() {
      this.closeEditPlaylist();
    },

    closeEditPlaylist() {
      this.showEditPlaylist = false;
      //clear fields
      this.selectedTracks = new Array<GoogleMedia>();
      this.editPlaylist = new Playlist("", "", "");
      this.selectedLibraryFolderId = 0;
      this.libraryTracksVisible = false;
      this.libraryMusicList = [];
    },

    programChanged() {
      this.releaseTracksVisible = false;
      this.selectedRelease = "";
      this.closeTrackPreview();
    },

    releaseChanged() {
      this.closeTrackPreview();
      this.musicList = new Array<GoogleMedia>();
      if (this.selectedRelease !== "") {
        this.getMusicList();
      }
    },

    showReleaseTracks() {
      this.releaseTracksVisible = !this.releaseTracksVisible;
      if (!this.releaseTracksVisible) {
        this.closeTrackPreview();
      }
    },

    async getMusicList() {
      // First, get release info to check contentSource
      let releaseEntity = null;
      
      // Find the release ID based on selected program and release number
      const program = this.programs.find(p => p.programName === this.selectedProgram.programName);
      if (program && program.fullReleases) {
        releaseEntity = program.fullReleases.find((r: any) => {
          const releaseWithZero = r.releaseName.length === 1 ? '0' + r.releaseName : r.releaseName;
          return releaseWithZero === this.selectedRelease;
        });
      }
      
      // Check if release uses server storage
      if (releaseEntity && releaseEntity.contentSource === 'SERVER') {
        // Use server API
        if (isPlatform("ios") || isPlatform("android")) {
          const tokenQuery = await Preferences.get({ key: "jwt" });
          const token = tokenQuery.value;

          const options = {
            url: `${process.env.VUE_APP_API_URL}api/releases/${releaseEntity.id}/media/music`,
            headers: { Authorization: `Bearer ${token}` },
            readTimeout: 60000,
          };

          await CapacitorHttp.get(options)
            .then((response) => {
              this.musicList = response.data;
            })
            .catch(() => {
              this.$router.replace("/badconnection");
            });
        } else {
          axios
            .get(`/api/releases/${releaseEntity.id}/media/music`)
            .then((response) => {
              this.musicList = response.data;
            })
            .catch((err) => {
              console.log("call error " + err);
            });
        }
        return;
      }
      
      // Original Google Drive logic (for backward compatibility)
      if (isPlatform("ios") || isPlatform("android")) {
        const tokenQuery = await Preferences.get({ key: "jwt" });
        const token = tokenQuery.value;

        const options = {
          url: `${process.env.VUE_APP_API_URL}api/google/media/${this.musicDirectory}`,
          headers: { Authorization: `Bearer ${token}` },
          readTimeout: 60000,
        };

        await CapacitorHttp.get(options)
          .then((response) => {
            this.musicList = response.data;
          })
          .catch(() => {
            this.$router.replace("/badconnection");
          });
      } else {
        axios
          .get(`/api/google/media/${this.musicDirectory}`)
          .then((response) => {
            this.musicList = response.data;
          })
          .catch((err) => {
            console.log("call error " + err);
          });
      }
    },

    addTrack(track: GoogleMedia): void {
      if (this.isAdded(track)) {
        this.removeTrack(track);
      } else {
        this.selectedTracks.push(track);
      }
    },
    removeTrack(track: GoogleMedia): void {
      const filesystemCustomUtils = new FilesystemCustomUtils();
      filesystemCustomUtils.removeFromDownloadedPlaylist(
        this.editPlaylist,
        track
      );

      this.selectedTracks = this.selectedTracks.filter((t) => {
        return t.id !== track.id;
      });
    },
    isAdded(track: GoogleMedia): boolean {
      const found = this.selectedTracks.find((t) => {
        return t.id === track.id;
      });
      return typeof found !== "undefined" && null !== found;
    },

    savePlaylist() {
      if (this.editPlaylist.name === "") {
        this.showAlert("Ошибка", "Укажите название плейлиста");
        return;
      }

      if (!this.selectedProgram?.programName?.trim() || !this.selectedProgram?.shortName?.trim()) {
        this.showAlert("Ошибка", "Выберите программу — без неё микс не отобразится в списке");
        return;
      }

      this.editPlaylist.programName = this.selectedProgram.programName || "";
      this.editPlaylist.programShortName = this.selectedProgram.shortName || "";
      this.editPlaylist.tracks = this.selectedTracks;
      if (
        typeof this.editPlaylist.id == "undefined" ||
        "" == this.editPlaylist.id
      ) {
        this.editPlaylist.id = `${this.selectedProgram.shortName
          }_${dayjs().day()}${dayjs().hour()}${dayjs().minute()}${dayjs().millisecond()}`;
      }
      this.editPlaylist.offline = false;

      const savingPlaylist = this.editPlaylist;
      const isNative = isPlatform("ios") || isPlatform("android");
      this.filesystemCustomUtils.storeFile(
        this.unicodeUtils.toBase64(JSON.stringify(this.editPlaylist)),
        this.PLAYLIST_PATH,
        `${this.PLAYLISTS_DIRECTORY}/${this.editPlaylist.id}`
      ).then((storeResult) => {
        const online = !this.globalContext.offlineMode;
        const syncToApi = online && (isNative ? storeResult : true);

        if (syncToApi) {
          const syncBody = {
            name: savingPlaylist.id,
            content: JSON.stringify(savingPlaylist),
            programId: this.selectedProgram?.id,
          };
          if (isNative) {
            Preferences.get({ key: "jwt" }).then((tokenQuery) => {
              const token = tokenQuery.value;
              CapacitorHttp.put({
                url: `${process.env.VUE_APP_API_URL}api/playlist`,
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
                data: syncBody,
              }).catch((e) => console.warn("playlist sync", e));

              if (storeResult) {
                CapacitorHttp.get({
                  url: `${process.env.VUE_APP_API_EXT_URL}api/google/file/base64/name/${this.selectedProgram.shortName}.png`,
                  headers: { Authorization: `Bearer ${token}` },
                  readTimeout: 60000,
                }).then((response) => {
                  Filesystem.writeFile({
                    path: `${this.PLAYLISTS_DIRECTORY}/${savingPlaylist.id}/${this.selectedProgram.shortName}.png`,
                    data: response.data,
                    directory: Directory.Data
                  });
                });
              }
            });
          } else {
            axios.put("/api/playlist", syncBody).catch((e) => console.warn("playlist sync", e));
          }
        } else if (!this.editPlaylist.offline && isNative) {
          this.removeDownloadedPlaylist(savingPlaylist);
        }

        let currentIndex = -1;
        this.playlists.forEach((p, index) => {
          if (p.id === this.editPlaylist.id) {
            currentIndex = index;
          }
        });

        if (currentIndex > -1) {
          this.playlists[currentIndex] = this.editPlaylist;
        } else {
          this.playlists.push(this.editPlaylist);
        }

        // save id const to open it after clearing editPlaylist container
        const editPlaylistId = this.editPlaylist.id;

        this.closeEditPlaylist();

        this.openPlaylist(editPlaylistId);
      });
    },

    reorderPlaylist(event: CustomEvent) {
      const movingTrack = this.selectedTracks.splice(event.detail.from, 1)[0];
      this.selectedTracks.splice(event.detail.to, 0, movingTrack);
      event.detail.complete();
    },

    openPlaylist(playlistId: string) {
      this.openPlayListView(playlistId);
    },

    openPlayListView(playlistId: string) {
      const foundPlaylist = this.playlists.find((p) => {
        return p.id == playlistId;
      });

      if (typeof foundPlaylist === "undefined" || null === foundPlaylist) return;

      Preferences.set({
        key: "playlistMeta",
        value: JSON.stringify(foundPlaylist),
      }).then(() => {
        this.$router.push({
          name: "PlayListView",
        });
      });
    },

    addToFavourites(playlistId: string, favourite: boolean) {
      const savingPlaylist = this.playlists.find((p) => {
        return p.id === playlistId;
      });

      if (undefined === savingPlaylist || null === savingPlaylist) return;

      savingPlaylist.favourite = favourite;

      const isNative = isPlatform("ios") || isPlatform("android");
      this.filesystemCustomUtils
        .storeFile(
          this.unicodeUtils.toBase64(JSON.stringify(savingPlaylist)),
          this.PLAYLIST_PATH,
          `${this.PLAYLISTS_DIRECTORY}/${savingPlaylist.id}`
        )
        .then((storeResult) => {
          if (!this.globalContext.offlineMode && (storeResult || !isNative)) {
            const prog = this.programs.find((p) => p.programName === savingPlaylist.programName);
            const syncBody = {
              name: savingPlaylist.id,
              content: JSON.stringify(savingPlaylist),
              programId: prog?.id,
            };
            if (isNative) {
              Preferences.get({ key: "jwt" }).then((tokenQuery) => {
                CapacitorHttp.put({
                  url: `${process.env.VUE_APP_API_URL}api/playlist`,
                  headers: {
                    Authorization: `Bearer ${tokenQuery.value}`,
                    "Content-Type": "application/json",
                  },
                  data: syncBody,
                }).catch((e) => console.warn("playlist favourite sync", e));
              });
            } else {
              axios.put("/api/playlist", syncBody).catch((e) => console.warn("playlist favourite sync", e));
            }
          }
        })
        .finally(() => {
          this.closeSliding();
        });
    },

    changePlaylist(playlistId: string) {
      const editPlaylist = this.playlists.find((p) => {
        return p.id === playlistId;
      });

      if (undefined === editPlaylist || null === editPlaylist) return;

      this.selectedTracks = editPlaylist.tracks;

      const foundProgram = this.programs.find((p) => {
        return p.programName === editPlaylist.programName;
      });
      if (typeof foundProgram !== "undefined" && foundProgram !== null) {
        this.selectedProgram = foundProgram;
      }

      this.showEditPlaylist = true;
      this.editPlaylist = editPlaylist;

      this.closeSliding();
    },

    async confirmRemovement(playlistId: string) {
      const alert = await alertController.create({
        header: "Подтверждение!",
        message: "Точно удаляем?",
        buttons: [
          {
            text: "Отмена",
            role: "cancel",
            cssClass: "secondary",
            id: "cancel-button",
          },
          {
            text: "Да",
            id: "confirm-button",
            handler: () => {
              this.removePlaylist(playlistId);
            },
          },
        ],
      });
      return alert.present();
    },

    removePlaylist(playlistId: string) {
      const isNative = isPlatform("ios") || isPlatform("android");
      const filesystemCustomUtils = new FilesystemCustomUtils();
      if (isNative) {
        filesystemCustomUtils.removePlaylistDirectory(playlistId);
      } else if (!this.globalContext.offlineMode) {
        axios
          .delete("/api/playlist", { data: { name: playlistId } })
          .catch((e) => console.warn("playlist delete", e));
      }

      this.playlists = this.playlists.filter((p) => {
        return p.id !== playlistId;
      });

      this.closeSliding();
    },

    copyPlaylist(playlist: Playlist) {
      const playlistCopy = new Playlist(
        `${playlist.name}_copy`,
        playlist.programName,
        playlist.programShortName
      );
      playlistCopy.id = `${playlist.programShortName
        }_${dayjs().day()}${dayjs().hour()}${dayjs().minute()}${dayjs().millisecond()}`;
      playlistCopy.tracks = playlist.tracks;
      playlistCopy.offline = false;

      const isNative = isPlatform("ios") || isPlatform("android");
      const copyProgram = this.programs.find((p) => p.programName === playlistCopy.programName);
      this.filesystemCustomUtils.storeFile(
        this.unicodeUtils.toBase64(JSON.stringify(playlistCopy)),
        this.PLAYLIST_PATH,
        `${this.PLAYLISTS_DIRECTORY}/${playlistCopy.id}`
      )
        .then((storeResult) => {
          const online = !this.globalContext.offlineMode;
          const syncToApi = online && (isNative ? storeResult : true);

          if (syncToApi) {
            const syncBody = {
              name: playlistCopy.id,
              content: JSON.stringify(playlistCopy),
              programId: copyProgram?.id,
            };
            if (isNative) {
              Preferences.get({ key: "jwt" }).then((tokenQuery) => {
                const token = tokenQuery.value;
                CapacitorHttp.put({
                  url: `${process.env.VUE_APP_API_URL}api/playlist`,
                  headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                  },
                  data: syncBody,
                }).catch((e) => console.warn("playlist copy sync", e));

                if (storeResult) {
                  CapacitorHttp.get({
                    url: `${process.env.VUE_APP_API_EXT_URL}api/google/file/base64/name/${playlist.programShortName}.png`,
                    headers: { Authorization: `Bearer ${token}` },
                    readTimeout: 60000,
                  }).then((response) => {
                    Filesystem.writeFile({
                      path: `${this.PLAYLISTS_DIRECTORY}/${playlistCopy.id}/${playlist.programShortName}.png`,
                      data: response.data,
                      directory: Directory.Data,
                    });
                  });
                }
              });
            } else {
              axios.put("/api/playlist", syncBody).catch((e) => console.warn("playlist copy sync", e));
            }
          }

          this.playlists.push(playlistCopy);

          this.openPlaylist(playlistCopy.id);
        })
        .finally(() => {
          this.closeSliding();
        });
    },

    removeDownloadedPlaylist(playlist: Playlist) {
      const filesystemCustomUtils = new FilesystemCustomUtils();
      filesystemCustomUtils.removeDownloadedPlaylist(playlist);
      playlist.offline = false;
    },

    groupBy(xs: any, key: any) {
      return xs.reduce((rv: any, x: any) => {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },

    async getFsPermissions(): Promise<boolean> {
      return new Promise<boolean>((resolve) => {
        Filesystem.checkPermissions().then((fsPermissions) => {
          if (fsPermissions.publicStorage.toString() !== "granted") {
            Filesystem.requestPermissions().then((requestFsPermissions) => {
              if (requestFsPermissions.publicStorage.toString() !== "granted") {
                resolve(false);
              } else {
                resolve(true);
              }
            });
          } else {
            resolve(true);
          }
        });
      });
    },

    async showAlert(alertTitle: string, alertMessage: string) {
      const alert = await alertController.create({
        header: alertTitle,
        message: alertMessage,
        buttons: ["OK"],
      });

      await alert.present();
    },
  },
});
</script>

<style scoped>
h1 {
  letter-spacing: 0.08em;
}

.program-main {
  background-color: black;
  opacity: 0.9;
}

.program-item {
  --background: rgba(67, 67, 67, 0.7);
  color: white;
  --color-hover: white;
  font-weight: bold;
  --min-height: 100px;
  margin-bottom: 5px;
  border-bottom: 1px solid rgba(67, 67, 67, .5);
}

.program-img-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}

.program-img-wrapper img {
  scale: 0.7;
  object-fit: scale-down;
}

.release-item {
  --background: rgba(134, 134, 134, 0.5);
  color: rgb(226, 226, 226);
  --min-height: 80px;
  font-weight: bold;
  border-bottom: 1px solid rgba(67, 67, 67, .5);
}

.release-item ion-label {
  font-family: 'Montserrat';
  color: white;
}

.release-favourite-item {
  border: unset !important;
  margin-bottom: 5px !important;
}

.favourites-content ion-item-option {
  margin-bottom: 5px !important;
}

.release-option {
  --background: var(--ion-color-orange);
}

.release-option ion-icon {
  color: white;
  scale: 1.5;
}

.release-container {
  position: relative;
}

.download-progress {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 100;
  background: var(--ion-color-orange);
  opacity: 0.6;
}

.orphan-playlists-wrap {
  margin: 10px 0 6px;
}

.orphan-program-header {
  --min-height: auto;
  margin-bottom: 6px;
}

.orphan-program-header ion-label {
  font-size: 0.82rem;
  line-height: 1.35;
  color: rgba(255, 255, 255, 0.75);
}

.add-playlist-button {
  font-size: 2em;
  --min-height: 60px;
  border-bottom: 1px solid rgba(67, 67, 67, .5);
}

.playlist-edit-modal {
  --backdrop-opacity: 0.55;
  --background: #101014;
  --width: min(100%, 720px);
  --max-width: 720px;
  --height: 100%;
  --border-radius: 0;
}

@media (min-width: 768px) {
  .playlist-edit-modal {
    --height: 92%;
    --border-radius: 20px;
  }
}

.playlist-edit-body {
  --background: linear-gradient(180deg, #16161c 0%, #0c0c10 45%, #111116 100%) !important;
  --overflow: auto;
}

.playlist-edit-body ion-list {
  height: auto !important;
  min-height: 0 !important;
}

.playlist-edit-scroll-inner {
  padding: 0 10px 12px;
  max-width: 720px;
  margin: 0 auto;
}

.playlist-edit-subbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 4px 10px;
  border-bottom: 1px solid rgba(255, 140, 0, 0.18);
  margin-bottom: 8px;
}

.playlist-edit-subbar__title {
  font-size: 0.95rem;
  font-weight: 700;
  font-family: "Montserrat", sans-serif;
  color: rgba(255, 255, 255, 0.94);
  line-height: 1.25;
  flex: 1 1 140px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.playlist-edit-subbar__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.playlist-edit-form-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  margin-bottom: 10px;
}

@media (min-width: 560px) {
  .playlist-edit-form-grid {
    grid-template-columns: 1fr 1fr;
  }

  .playlist-edit-form-grid .playlist-edit-field--compact:first-child {
    grid-column: 1 / -1;
  }
}

@media (min-width: 720px) {
  .playlist-edit-form-grid {
    grid-template-columns: 1.2fr 1fr 0.85fr;
  }

  .playlist-edit-form-grid .playlist-edit-field--compact:first-child {
    grid-column: auto;
  }
}

.playlist-edit-scroll-pad {
  height: 24px;
}

.playlist-edit-track-list {
  padding-bottom: 4px;
}

.playlist-edit-toolbar {
  --background: linear-gradient(135deg, #c2410c 0%, #9a3412 55%, #7c2d12 100%);
  --border-width: 0;
  --min-height: 52px;
}

.playlist-edit-toolbar-title {
  color: rgba(255, 255, 255, 0.95) !important;
  font-weight: 700;
  letter-spacing: 0.06em;
  font-size: 0.78rem;
  text-transform: uppercase;
}

.playlist-edit-save-btn {
  --color: rgba(255, 255, 255, 0.98) !important;
  font-weight: 700;
  font-size: 0.85rem;
}

.playlist-edit-close-btn {
  font-weight: 600;
  --color: rgba(255, 255, 255, 0.92) !important;
}

.playlist-edit-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.3rem 0.55rem;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 600;
  font-family: "Montserrat", sans-serif;
  background: rgba(255, 255, 255, 0.07);
  color: rgba(255, 255, 255, 0.88);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.playlist-edit-chip ion-icon {
  font-size: 0.95rem;
  color: var(--ion-color-orange);
}

.playlist-edit-chip--tiny {
  padding: 0.22rem 0.45rem;
  font-size: 0.62rem;
}

.playlist-edit-chip--tiny ion-icon {
  font-size: 0.8rem;
}

.playlist-edit-field {
  --background: rgba(32, 32, 40, 0.92) !important;
  --border-radius: 16px !important;
  --inner-padding-end: 12px;
  --inner-padding-start: 14px;
  --padding-top: 10px;
  --padding-bottom: 12px;
  margin-bottom: 11px !important;
  border: 1px solid rgba(255, 140, 0, 0.14) !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.22);
  align-items: flex-start;
}

.playlist-edit-field--compact {
  --padding-top: 4px;
  --padding-bottom: 4px;
  margin-bottom: 0 !important;
  min-height: 52px;
}

.playlist-edit-label {
  color: rgba(255, 190, 130, 0.92) !important;
  font-weight: 600 !important;
  font-size: 0.68rem !important;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 2px;
}

.playlist-edit-input,
.playlist-edit-select {
  width: 100%;
  max-width: 100%;
  --color: rgba(255, 255, 255, 0.95);
  --placeholder-color: rgba(255, 255, 255, 0.35);
  font-family: "Montserrat", sans-serif;
  font-size: 0.95rem;
}

.playlist-edit-expand-wrap {
  display: flex;
  justify-content: center;
  margin: 2px 0 12px;
}

.playlist-edit-expand-btn {
  --border-color: rgba(255, 160, 60, 0.5);
  --color: rgba(255, 255, 255, 0.94);
  font-weight: 600;
  font-size: 0.78rem;
  --padding-start: 14px;
  --padding-end: 16px;
}

.playlist-edit-expand-wrap--open .playlist-edit-expand-btn {
  --border-color: rgba(235, 68, 90, 0.5);
}

.playlist-edit-section-head {
  --background: transparent;
  min-height: 44px;
  border-bottom: 1px solid rgba(255, 140, 0, 0.22);
  margin: 4px 0 10px;
  padding-inline-start: 4px;
  padding-inline-end: 4px;
}

.playlist-edit-section-title {
  font-size: 0.88rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.02em;
}

.playlist-edit-section-meta {
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  color: rgba(255, 200, 150, 0.88) !important;
}

.playlist-edit-hint {
  display: block;
  padding: 4px 8px 14px;
  margin: 0 4px;
  font-size: 0.78rem;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.48);
  font-family: "Montserrat", sans-serif;
}

.playlist-container {
  --background: #1e1e1e !important;
}

.playlist-container ion-list {
  height: 100%;
  background: #1e1e1e !important;
}

.playlist-container ion-list-header {
  font-size: 1.5em;
  font-weight: bold;
  color: white;
}

.playlist-name {
  color: white !important;
  width: 80%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.playlist-name-input {
  font-family: 'Montserrat';
}

.playlist-header-label {
  color: white !important;
  width: 50%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.playlist-header-icon {
  font-size: 0.8em;
  color: white;
}

.playlist-header-button {
  color: white !important;
  --color: white !important;
  --background-activated: transparent !important;
  --border-color: var(--ion-color-orange);
}

.playlist-header-button ion-icon {
  font-size: 1.5em;
  margin-bottom: 3px;
  color: white !important;
}

.remove-download-button {
  font-size: 0.8em !important;
}

.column-buttons {
  display: flex;
  width: 100%;
  justify-content: center;
  flex-flow: column;
}

.download-button {
  display: flex;
  width: 100%;
  justify-content: center;
}

.download-button ion-button {
  --border-width: 0 !important;
}

.playlist-container.playlist-edit-body .playlist-content ion-item {
  --background: rgba(255, 255, 255, 0.06) !important;
  --border-radius: 12px !important;
  color: white;
  margin-bottom: 6px !important;
  border: 1px solid rgba(255, 255, 255, 0.07) !important;
}

.playlist-container ion-label {
  color: white;
}

.playlist-content ion-content {
  max-height: 50vh !important;
  --background: #1e1e1e;
}

.playlist-content ion-label {
  color: white !important;
}

.playlist-content ion-item {
  color: white !important;
  --border-radius: 0 !important;
  margin-bottom: 2px !important;
}

.playlist-content ion-item-option {
  margin-bottom: 2px !important;
}

.add-button-container {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}

.add-button-container ion-button {
  --background: var(--ion-color-orange);
  --background-activated: var(--ion-color-orange-tint);
  width: 50px;
  height: 50px;
  --border-radius: 25px;
}

.close-button {
  transform: rotateZ(45deg);
}

.add-button {
  color: #c0c0be;
}

.play-button {
  color: #c0c0be;
}

.preview-item {
  position: relative;
}

.preview-progress {
  position: absolute;
  bottom: 0;
  height: 2px;
  background: var(--ion-color-orange);
}

.danger-button {
  color: var(--ion-color-danger);
}

.danger-background ion-button {
  --background: var(--ion-color-danger) !important;
}

.playlist-fake-item {
  --background: transparent !important;
}


ion-toolbar {
  --background: #1e1e1e;
}

ion-text {
  color: white;
}

.program-img-wrapper {
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
}

.download-progress-bar {
  height: 5px;
  --progress-background: var(--ion-color-orange);
  --background: #c0c0be;
}

.offline-toggle {
  --background: white;
  --background-checked: var(--ion-color-orange);
  --handle-background: white;
  --handle-background-checked: white;
}

.playlist-total-duration {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  font-size: 1.5em;
  font-weight: bold;
}

.fake-footer {
  height: 20vh;
}

.offline-indicator {
  font-size: 1.2em;
  margin-right: 8px;
}

ion-item::part(detail-icon) {
  color: white;
}
</style>